<template>
  <div class="floating__contact">
    <ul class="section-box__footer--contact">
      <li :style="{ color: floatingContactColor }"><span :style="{ color: floatingContactLetterColor }">m:</span> <a href="mailto:hello@intervi.co">hello[at]intervi.co.</a></li>
      <li :style="{ color: floatingContactColor }"><span :style="{ color: floatingContactLetterColor }">p:</span> <a href="tel:+48510069993">+48 510 069 993</a></li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "FloatingContact",
  data() {
    return {
      props: ['noMargin']
    };
  },
  props: ["floatingContactColor", "floatingContactLetterColor"]
};
</script>



// WEBPACK FOOTER //
// src/components/small-components/FloatingContact.vue